<template>
    <Page :pageIndex="$store.state.filteredPageLabels.indexOf($store.state.currentPage) + 1" />
</template>
<script>
import Page from '@/components/handlers/Page.vue';

export default {
    name: 'Presentation',
    components: {
        Page
    }
};

</script>
